import React from "react";
import Page from "components/Page";
import { Props } from "./SnaggingCategoryCustomTypes";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const SnaggingCategoryCustomTypes = lazyWithRetry(() =>
  import("./SnaggingCategoryCustomTypes")
);

export default (props: Props) => (
  <Page>
    <SnaggingCategoryCustomTypes {...props} />
  </Page>
);
